import { memo } from 'react';

import '@/components/atomic/templates/navigation/breadcrumbs/components/breadcrumb/content/item';
import BreadcrumbContentItem from '@/components/atomic/templates/navigation/breadcrumbs/components/breadcrumb/content/item';
import withExposer from '@/hocs/with-exposer';
import { SecondaryNavLinkHandler } from '@/state/slices/secondary-nav/typings';
import { BasicComponentProps } from '@/typings/generic';

interface BreadcrumbContentProps extends BasicComponentProps {
	subNavList?: SecondaryNavLinkHandler['subNavList'];
	dropdownOpen?: boolean;
	index: number;
}

const BreadcrumbContentComponent: React.FC<BreadcrumbContentProps> = ({
	subNavList,
	dropdownOpen,
	index,
}) => {
	if (!subNavList || subNavList.length === 0 || !dropdownOpen) return null;

	return (
		<ul className='dxnav__breadcrumb-dropdown'>
			{subNavList.map((subnavItem) => (
				<BreadcrumbContentItem
					key={`${subnavItem.title}_${subnavItem.evaluatedLink}`}
					subnavItem={subnavItem}
					index={index}
				/>
			))}
		</ul>
	);
};

const BreadcrumbContent = memo(
	withExposer(BreadcrumbContentComponent, 'breadcrumb_content'),
);

export default BreadcrumbContent;
